let googleMapsPromise: Promise<void> | null = null;

declare global {
  interface Window {
    google: typeof google;
  }
}

export function loadGoogleMaps(): Promise<void> {
  if ((window.google as any)?.maps?.importLibrary) {
    return Promise.resolve();
  }

  if (!googleMapsPromise) {
    googleMapsPromise = new Promise((resolve, reject) => {
      const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

      if (!apiKey) {
        reject(new Error("Google Maps API key is missing"));
        return;
      }

      const w = window as any;
      const d = document;
      const googleObj = (w.google = w.google || {});
      const maps = (googleObj.maps = googleObj.maps || {});
      const libraries = new Set<string>();
      let bootstrapPromise: Promise<void> | null = null;

      const loadScript = () => {
        if (bootstrapPromise) return bootstrapPromise;

        bootstrapPromise = new Promise<void>((res, rej) => {
          const script = d.createElement("script");
          const params = new URLSearchParams();

          params.set("key", apiKey);
          params.set("v", "weekly");
          params.set("loading", "async");
          params.set("callback", "google.maps.__ib__");

          if (libraries.size > 0) {
            params.set("libraries", Array.from(libraries).join(","));
          }

          (maps as any).__ib__ = () => {
            res();
          };

          script.src = `https://maps.googleapis.com/maps/api/js?${params.toString()}`;
          script.async = true;
          script.defer = true;
          script.onerror = () =>
            rej(new Error("Failed to load Google Maps"));

          d.head.appendChild(script);
        });

        return bootstrapPromise;
      };

      if (!maps.importLibrary) {
        maps.importLibrary = (library: string, ...args: any[]) => {
          libraries.add(library);
          return loadScript().then(() => maps.importLibrary(library, ...args));
        };
      }

      resolve();
    });
  }

  return googleMapsPromise;
}